import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useLocation, Link } from 'react-router-dom';
//import SidebarData from '../sidebars/sidebardata/SidebarData';

const BreadCrumbs = () => {
  const location = useLocation();
  const firstUrl = location.pathname.split('/')[1];
  const secondUrl = location.pathname.split('/')[2];
  return (
    <div>
      <h5 className="mb-0 text-capitalize">{secondUrl ? `${secondUrl}` : `${firstUrl}`}</h5>
      <Breadcrumb>
        <BreadcrumbItem to="/" tag={Link} className="text-decoration-none link-info fw-normal">
          Home
        </BreadcrumbItem>
        {firstUrl ? <BreadcrumbItem active>{firstUrl}</BreadcrumbItem> : ''}
        {secondUrl ? <BreadcrumbItem active>{secondUrl}</BreadcrumbItem> : ''}
      </Breadcrumb>
    </div>
  );
};

export default BreadCrumbs;
